import {
  useLazyGetDownloadCleanedFileQuery,
  useLazyGetDownloadProjectReportQuery
} from '@api/projects';
import { DOWNLOADED_ON_LOCAL } from '@constants/eventNames';
import { sendAmplitudeData } from '@utils/amplitude';

const useDownloadReport = () => {
  const [getDownloadProjectReportBlob] = useLazyGetDownloadProjectReportQuery();
  const [getDownloadCleanedFileBlob] = useLazyGetDownloadCleanedFileQuery();

  const downloadReport = async (id: string, name: string) => {
    try {
      if (id && name)
        await getDownloadProjectReportBlob({
          id,
          name: encodeURIComponent(name)
        }).unwrap();
      sendAmplitudeData(DOWNLOADED_ON_LOCAL, { Type: 'Report' });
    } catch (err) {
      console.log(err);
    }
  };
  const downloadCleanedFile = async (id: string, name: string) => {
    try {
      if (id && name)
        await getDownloadCleanedFileBlob({
          id,
          name: encodeURIComponent(name)
        }).unwrap();
      sendAmplitudeData(DOWNLOADED_ON_LOCAL, { Type: 'Cleaned File' });
    } catch (err) {
      console.log(err);
    }
  };

  return {
    downloadReport,
    downloadCleanedFile
  };
};

export default useDownloadReport;
